export type ShareOptions = {
  title: string
  text: string
  url: string
  imageElement: HTMLImageElement
  imageFilename: string
}

export class Share {
  static async share({
    title,
    text,
    url,
    imageElement,
    imageFilename,
  }: ShareOptions) {
    const shareData: Partial<ShareOptions & { files: Array<File> }> = {}

    if (title) {
      shareData.title = title
    }

    if (text) {
      shareData.text = text
    }

    if (url) {
      shareData.url = url
    }

    if (imageElement) {
      // Fetch the image data
      const response = await fetch(imageElement.getAttribute('src') as string)
      const imageBlob = await response.blob()

      shareData.files = [
        new File([imageBlob], imageFilename, {
          type: imageBlob.type,
        }),
      ]
    }

    await navigator.share(shareData)
  }
}
